import React from 'react';

// Abacus: HA_PULSE_SKELETON_ABC
import {SkeletonLoading} from '../../abacus/skeleton-abc';

export default function LazyFourPack({image1, image2, image3, image4, isLoading}) {
    return (
        <div className="four-pack">
            <div className="four-pack__grid">
                <div className="four-pack__column">
                    <SkeletonLoading loading={isLoading}>
                        <div
                            className="four-pack__image four-pack__image--rounded-top-left"
                            style={(image1 ? {backgroundImage: `url(${image1})`} : {})}
                        />
                    </SkeletonLoading>
                    <div className="four-pack__separator" />
                    <SkeletonLoading loading={isLoading}>
                        <div
                            className="four-pack__image four-pack__image--rounded-bottom-left"
                            style={(image3 ? {backgroundImage: `url(${image3})`} : {})}
                        />
                        </SkeletonLoading>
                </div>
                <div className="four-pack__separator" />
                <div className="four-pack__column">
                    <SkeletonLoading loading={isLoading}>
                        <div
                            className="four-pack__image four-pack__image--rounded-top-right"
                            style={(image2 ? {backgroundImage: `url(${image2})`} : {})}
                        />
                    </SkeletonLoading>
                    <div className="four-pack__separator" />
                    <SkeletonLoading loading={isLoading}>
                        <div
                            className="four-pack__image four-pack__image--rounded-bottom-right"
                            style={(image4 ? {backgroundImage: `url(${image4})`} : {})}
                        />
                    </SkeletonLoading>
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/universal/abacus/waterfall/lazy-four-pack.js